export default class MessagesHelper {
  // Заменяет все теги <br/> в тексте сообщения на \n, что позволяет не пользоваться атрибутом dangerouslySetInnerHTML
  // так как текст сообщения идет извне, мало ли что туда передадут
  static convertHtmlBrToNewlines = (messageText: string | null) => {
    if (!messageText) {
      return;
    }

    return messageText.replace(/<br\s*\/?>/gi, '\n');
  };
}
